module.exports = __webpack_public_path__ + "static/img/tocImage1.651295c9.jpg";